import { SignInPage } from './SignInPage';
import { withSignInPage } from './withSignInPage';

const ConnectedSignInPage = withSignInPage(SignInPage);

export { ConnectedSignInPage as SignInPage };
